// Batch configuration for different batch types
// Customize behavior per batch type (bulk_analysis, dealflow_shortlist, etc.)

export const BATCH_TYPE_CONFIG = {
  bulk_analysis: {
    label: 'Bulk Analysis',
    closeOnCompletion: false,
    autoCloseDelayMs: 5000, // Close after 5 seconds of completion
    notificationTitle: 'Pitch Deck Analysis Complete',
    notificationBody: (total) => `${total} file${total !== 1 ? 's' : ''} analyzed.`,
    autoRemoveCompletedAfterMs: 60 * 60 * 1000, // 1 hour
    refetchIntervalProcessing: 3000, // 3 seconds
    refetchIntervalComplete: false, // Don't poll when complete
    enableNotifications: true,
  },
  dealflow_shortlist: {
    label: 'AI Shortlist',
    closeOnCompletion: false,
    autoCloseDelayMs: 5000, // Close after 5 seconds of completion
    notificationTitle: 'AI Shortlist Complete',
    // "analyzed", not "shortlisted": the run assigns either the shortlisted or the
    // rejected status per startup, so the batch total is an analysed count.
    notificationBody: (total) => `${total} startup${total !== 1 ? 's' : ''} analyzed.`,
    autoRemoveCompletedAfterMs: 60 * 60 * 1000, // 1 hour
    refetchIntervalProcessing: 2000, // 2 seconds (auto-managed by hook)
    refetchIntervalComplete: false,
    enableNotifications: true,
  },
  // No batch id exists for auto-shortlist, so this one is driven entirely by
  // useAutoShortlistRefresh - nothing here polls.
  auto_shortlist: {
    label: 'Auto-Shortlist',
    closeOnCompletion: false,
    autoCloseDelayMs: 5000,
    notificationTitle: 'Auto-Shortlist Complete',
    notificationBody: () => 'New startups have been shortlisted.',
    autoRemoveCompletedAfterMs: 60 * 60 * 1000,
    refetchIntervalProcessing: false,
    refetchIntervalComplete: false,
    enableNotifications: false,
  },
  // Add more batch types as needed
  // custom_type: {
  //   label: 'Custom Analysis',
  //   closeOnCompletion: true,
  //   autoCloseDelayMs: 5000, // Close after 5 seconds
  //   notificationTitle: 'Custom Analysis Complete',
  //   notificationBody: (total) => `Analysis finished: ${total} items`,
  //   autoRemoveCompletedAfterMs: 30 * 60 * 1000, // 30 minutes
  //   refetchIntervalProcessing: 2000,
  //   refetchIntervalComplete: false,
  //   enableNotifications: true,
  // },
};

/**
 * Get configuration for a batch type
 * @param {string} batchType - The batch type key
 * @returns {object} Configuration object with defaults
 */
export const getBatchConfig = (batchType) => {
  const defaultConfig = {
    label: batchType,
    closeOnCompletion: false,
    autoCloseDelayMs: null,
    notificationTitle: 'Processing Complete',
    notificationBody: (total) => `${total} items processed.`,
    autoRemoveCompletedAfterMs: 60 * 60 * 1000,
    refetchIntervalProcessing: 3000,
    refetchIntervalComplete: false,
    enableNotifications: true,
  };

  return {
    ...defaultConfig,
    ...(BATCH_TYPE_CONFIG[batchType] || {}),
  };
};

/**
 * Update batch configuration at runtime
 * Useful for feature flags, user preferences, etc.
 * @param {string} batchType - The batch type to update
 * @param {object} config - Partial config to merge
 */
export const updateBatchConfig = (batchType, config) => {
  BATCH_TYPE_CONFIG[batchType] = {
    ...getBatchConfig(batchType),
    ...config,
  };
};
